import axios from "axios";

// Use the current browser origin so API calls hit the same domain the user is on.
// Works automatically across:
//   • preview  (pitch-finder-46.preview.emergentagent.com)
//   • prod      (pitch-finder-46.emergent.host)
//   • custom    (keyfinder.tech)
// Falls back to REACT_APP_BACKEND_URL only for local Node SSR / build-time scripts.
const BACKEND_URL =
  typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
